import React, { useEffect } from "react";
import "./style.css";
import {
  Breadcrumb,
  Row,
  Col,
  Avatar,
  Spin,
  List,
  message,
  Popover,
  Card,
  Form,
  Select,
  Switch,
  Checkbox,
} from "antd";
import {
  EditOutlined,
  SyncOutlined
} from "@ant-design/icons";
import Container from "../Layout/Container";
import InfiniteScroll from 'react-infinite-scroller';
import { useHistory, useLocation, Link } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAdminUser, getOrgUnitForAdminAsyn, updateOrgUnitForAdminAsyn, updateUsersPermissionsAsyn, viewAdminUserSelector, clearState, getUsersInscope, clearStateDataInScope, changeUserStatusInscope } from './viewUserSlice';
import Can from '../../config/Can';
const { Meta } = Card;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;

const clerkUsersOptions = [
  {
    title: 'Seen Stamp',
    dataIndex: 'seenStamps',
  },
  {
    title: 'Print Document',
    dataIndex: 'printDocument',
  },
  {
    title: 'add Document',
    dataIndex: 'addDocuments',
  },
];


const chdsUsersOptions = [
  {
    title: 'Print Document',
    dataIndex: 'printDocument',
  },
  {
    title: 'Initiate AdHoc Process',
    dataIndex: 'initiateAdHocProcess',
  },
  {
    title: 'add Document',
    dataIndex: 'addDocuments',
  },
];

const adsUsersOptions = [
  {
    title: 'Print Document',
    dataIndex: 'printDocument',
  },
  {
    title: 'add Document',
    dataIndex: 'addDocuments',
  },
];

const titleCase = (str) => {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

const capitalizeFirstLetterPermisson = (string) => {
  let str = string.replace(/([a-z])([A-Z])/g, '$1 $2')
  let titlestr = titleCase(str);
  let strArry = titlestr.split('/');
  let str1Arr = [];
  strArry.map((v) => {
    let c = titleCase(v);
    str1Arr.push(c);
  });
  let finalStr = str1Arr.join('/');
  return finalStr;
}


const getPermissions = (userdata) => {
  let permissions = [];
  if (userdata && userdata.type == 'Clerk') {
    let ckpermissions = userdata.clerkPermission ? userdata.clerkPermission.clerkPermission : [];
    permissions = ckpermissions.map((val) => {
      return (<p style={{
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 22,
        color: "black",
        marginBottom: 10,
      }}>{capitalizeFirstLetterPermisson(val)}</p>);
    })
  }

  if (userdata && userdata.type == 'CHD') {
    let ckpermissions = userdata.CHDPermission ? userdata.CHDPermission.CHDPermission : [];
    permissions = ckpermissions.map((val) => {
      return (<p style={{
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 22,
        color: "black",
        marginBottom: 10,
      }}>{capitalizeFirstLetterPermisson(val)}</p>);
    })
  }

  if (userdata && userdata.type == "DD's & AD's") {
    let ckpermissions = userdata.DDsAndADPermission ? userdata.DDsAndADPermission.DDsAndADPermission : [];
    permissions = ckpermissions.map((val) => {
      return (<p style={{
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 22,
        color: "black",
        marginBottom: 10,
      }}>{capitalizeFirstLetterPermisson(val)}</p>);
    })
  }

  //   const listItems = numbers.map((number) =>
  //   <li>{number}</li>
  // );
  return (permissions);
}


export default function ViewUser() {

  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [imageUrl, setimageUrl] = React.useState("./images/default-View-SubAdmin-Img.png");
  const [form] = Form.useForm();

  const { isFetching, isSuccess, isError, errorMessage, response, orgUnitData, imagePath, userdata, isDataInScopeSuccess, dataInscope, userCount, } = useSelector(
    viewAdminUserSelector
  );


  const [clerkUsersList, setlerkUsersList] = React.useState([]);

  const clerkUsersChange = (list) => {
    setlerkUsersList(list);
    let data = {
      "username": userdata.username,
      "permissionArray": list,
      "userType": userdata.type,
    };
    // console.log("data => ", data);
    dispatch(updateUsersPermissionsAsyn(data));
  };

  const [chdsUsersList, setchdsUsersList] = React.useState([]);
  const chdsUsersChange = (list) => {
    setchdsUsersList(list);
    let data = {
      "username": userdata.username,
      "permissionArray": list,
      "userType": userdata.type,
    };
    // console.log("data => ", data);
    dispatch(updateUsersPermissionsAsyn(data));
  };


  const [adsUsersList, setadsUsersList] = React.useState([]);
  const adsUsersChange = (list) => {
    setadsUsersList(list);
    let data = {
      "username": userdata.username,
      "permissionArray": list,
      "userType": userdata.type,
    };
    // console.log("data => ", data);
    dispatch(updateUsersPermissionsAsyn(data));
  };


  const [loading, setDataLoading] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [viewallUserData, setDataSource] = React.useState([]);

  const [BranchData, setBranchData] = React.useState([]);

  const handleEditClick = () => {
    history.push({
      pathname: '/edit-user',
      state: { username: location.state.username }
    });
  }


  useEffect(() => {

    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(fetchAdminUser(location.state.username));
    dispatch(getUsersInscope(`${location.state.username}?page=${page}`));
    dispatch(getOrgUnitForAdminAsyn(location.state.username));
  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }

    if (isSuccess) {

      setLoading(false);
      setTimeout(() => {



        if (userdata.clerkPermission && userdata.clerkPermission.clerkPermission) {
          let dref = [];
          userdata.clerkPermission.clerkPermission.forEach(deptval => {
            dref.push(deptval)
          });
          setlerkUsersList(dref);
        }


        if (userdata.CHDPermission && userdata.CHDPermission.CHDPermission) {
          let dref = [];
          userdata.CHDPermission.CHDPermission.forEach(deptval => {
            dref.push(deptval)
          });
          setchdsUsersList(dref);
        }

        if (userdata.DDsAndADPermission && userdata.DDsAndADPermission.DDsAndADPermission) {
          let dref = [];
          userdata.DDsAndADPermission.DDsAndADPermission.forEach(deptval => {
            dref.push(deptval)
          });
          setadsUsersList(dref);
        }


        if (userdata && userdata.profilePic && userdata.profilePic.length) {
          setimageUrl(userdata.profilePic);
        }
        else {
          setimageUrl("./images/default-View-SubAdmin-Img.png");
        }
        setLoading(false);
      }, 1000);

    }

    if (isDataInScopeSuccess) {
      setLoading(false);
      setDataSource(dataInscope);

    }

  }, [isError, isSuccess, isDataInScopeSuccess, dataInscope, userdata, setLoading, setToast]);


  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }



  const handleInfiniteOnLoad = () => {

    let data = viewallUserData;
    // console.log('u data cnt = ' + data.length + ' ucount=' + userCount)
    if (data.length > userCount) {
      message.warning('Infinite List loaded all');
      setDataLoading(false);
      setHasMore(false);
      return;
    }
    let pageCount = page + 1;
    let qry = location.state.username + '?page=' + pageCount;
    dispatch(getUsersInscope(qry)).then(res => {

      data = data.concat(res.payload.data.data);

      setDataLoading(false);
      setHasMore(false);
      setDataSource(data);
      let newpage = page + 1;
      setPage(newpage);
      // this.setState({
      //   data,
      //   loading: false,
      // });
    });
  };


  let dataSource = isLoading
    ? []
    : viewallUserData ? viewallUserData : [];


  const onChange = (checked, sendData) => {

    if (sendData.exclude.length) {
      const data = {
        "username": location.state.username,
        "action": "remove",
        "data": sendData.username,
      };
      dispatch(changeUserStatusInscope(data));
    }
    else {
      const data = {
        "username": location.state.username,
        "action": "add",
        "data": sendData.username,
      };
      dispatch(changeUserStatusInscope(data));
    }

    setTimeout(() => {

      let pageCount = page + 1;
      let qry = location.state.username + '?page=' + 1;
      dispatch(getUsersInscope(qry)).then(res => {
        setDataSource([]);
        let newdata = viewallUserData.concat(res.payload.data.data);

        setDataLoading(false);
        setHasMore(true);
        // setDataSource(newdata);
        let newpage = page + 1;
        setPage(1);
        // var elmnt = document.getElementById("scrollableDiv");

        // var y = elmnt.scrollTo(0, 0);
      });
    }, 1000);

  };


  // const getOrgUnitList = () => {
  //   let children = [];
  //   let OrgUnitList = orgUnitData && orgUnitData.result ? orgUnitData.result : [];

  //   if (OrgUnitList && OrgUnitList.length > 0) {
  //     for (let i = 0; i < OrgUnitList.length; i++) {
  //       if (OrgUnitList[i].parentBranch) {
  //         children.push(<Option key={i.toString() + i} subject={OrgUnitList[i].q_str} value={OrgUnitList[i].deptTypeName}>{OrgUnitList[i].deptTypeName} Directorate of "{OrgUnitList[i].parentBranch}"</Option>);
  //       }
  //       else {
  //         children.push(<Option key={i.toString() + i} subject={OrgUnitList[i].q_str} value={OrgUnitList[i].deptTypeName}>{OrgUnitList[i].deptTypeName}</Option>);
  //       }
  //     }
  //   }

  //   return children;
  // }


  const getOrgUnitList = () => {
    let children = [];
    let dummyArray = [];
    let OrgUnitList = orgUnitData && orgUnitData.result ? orgUnitData.result : [];

    if (OrgUnitList && OrgUnitList.length > 0) {
      for (let i = 0; i < OrgUnitList.length; i++) {

        if (OrgUnitList[i].alreadyChecked === true) {
          if (OrgUnitList[i].q_str && OrgUnitList[i].q_str.bd_name) {
            dummyArray.push(OrgUnitList[i].q_str.bd_name)
          }

          if (OrgUnitList[i].q_str && OrgUnitList[i].q_str.io_name) {
            dummyArray.push(OrgUnitList[i].q_str.io_name)
          }

          if (OrgUnitList[i].q_str && OrgUnitList[i].q_str.b_name) {
            dummyArray.push(OrgUnitList[i].q_str.b_name)
          }
        }


        if (OrgUnitList[i].parentBranch) {
          children.push(<Option key={i.toString() + i} subject={OrgUnitList[i].q_str} value={OrgUnitList[i].deptTypeName}>{OrgUnitList[i].deptTypeName} Directorate of "{OrgUnitList[i].parentBranch}"</Option>);
        }
        else {
          children.push(<Option key={i.toString() + i} subject={OrgUnitList[i].q_str} value={OrgUnitList[i].deptTypeName}>{OrgUnitList[i].deptTypeName}</Option>);
        }
      }
    }

    form.setFieldsValue({
      mydata: dummyArray
    });
    return children;
  }


  const onOrgListChange = (event, chnageData) => {

    // console.log(" chnageData =" + JSON.stringify(chnageData, null, 4));

    let dummyArray = []
    for (var i = 0; i < chnageData.length; i++) {
      dummyArray.push(chnageData[i].subject)
    }

    // console.log(dummyArray);
    dispatch(updateOrgUnitForAdminAsyn({ "communicationList": dummyArray, "username": userdata.username }));

  }


  return (
    <>
      <Container>
        <Breadcrumb
          style={{ margin: "16px 0", paddingLeft: 50, marginBottom: 0 }}
          separator=">"
        >
          <Breadcrumb.Item><Link to="/manage-users">Users</Link></Breadcrumb.Item>
          <Breadcrumb.Item>View Details</Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>

            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <Row
              style={{
                paddingTop: 35,
                paddingBottom: 20,
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                borderTop: "1px solid #dfe0eb",
                borderBottom: "2px solid #e8e8e8",
                backgroundColor: "#ffffff"
              }}
            >
              <Col span="2"></Col>
              <Col span="19">
                <h1
                  style={{
                    fontWeight: "bold",
                    fontStyle: "normal",
                    fontSize: 24,
                  }}
                >
                  User Details
                </h1>
              </Col>
              <Col span="3">
                <Can I="manageUsersTab" a="editUser">
                  <h1
                    onClick={handleEditClick}
                    style={{
                      fontWeight: "bold",
                      cursor: "pointer",
                      fontSize: 24,
                    }} > <EditOutlined /> &nbsp;Edit</h1>
                </Can>
              </Col>
            </Row>

            <div className="user-details-page-row-designs"
              style={{
                paddingTop: 35,
                paddingBottom: 20,
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                borderTop: "1px solid #dfe0eb",
                borderBottom: "2px solid #e8e8e8",
                backgroundColor: "#ffffff"
              }}
            >
              <Row style={{ paddingTop: 20, paddingBottom: 20, width: "-webkit-fill-available" }}>
                <Col span="2"></Col>
                <Col span="6">
                  <Avatar src={imageUrl} className="custom-avtar-css" size="large" />
                </Col>
                <Col span="7">
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                    }}
                  >
                    Full Name
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {userdata && userdata.name}
                  </p>

                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                      marginTop: 15,
                    }}
                  >
                    Staff/User Number
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {userdata && userdata.serviceNumber}
                  </p>

                  {/* <p
                                style={{
                                  fontStyle: "normal",
                                  fontWeight: "normal",
                                  fontSize: 16,
                                  color: "#6B778C",
                                  marginBottom: 0,
                                  marginTop: 15,
                                }}
                              >
                                Contact No
                              </p> 
                              <p
                                style={{
                                  fontStyle: "normal",
                                  fontWeight: "normal",
                                  fontSize: 22,
                                  color: "black",
                                  marginBottom: 0,
                                }}
                              >
                                {userdata && userdata.phone}
                              </p>  */}
                </Col>
                <Col span="9">
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                    }}
                  >
                    User Name
                  </p>

                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {userdata && userdata.username}
                  </p>

                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                      marginTop: 15,
                    }}
                  >
                    Email ID
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {userdata && userdata.email}
                  </p>
                </Col>
                <Col span="2"></Col>
                <Col span="6"></Col>
                <Col span="10">
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                      marginTop: 5,
                    }}
                  >
                    Contact No
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {userdata && userdata.phone}
                  </p>
                </Col>
              </Row>
              <Row
                style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: "-webkit-fill-available"
                }}
              >
                <Col span="2"></Col>
                <Col span="6">
                  <h2 style={{
                    padding: "25px",
                    paddingLeft: "0px",
                    color: "#6b778c",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}>Appointments</h2>
                </Col>
                <Col span="14">
                  <Row>
                    <Col span={24}>
                      <p className="manage-checkbox-css">Type</p>
                      <div className="mar-t-15">
                        <p style={{
                          fontStyle: "normal",
                          fontWeight: "normal",
                          fontSize: 22,
                          color: "black",
                          marginBottom: 0,
                        }}>
                          {userdata && userdata.type}
                        </p>
                      </div>
                    </Col>
                  </Row>


                  <Row>
                    <Col span={12}>
                      <p className="manage-checkbox-css">Appointment</p>
                      <div className="mar-t-15">
                        <p style={{
                          fontStyle: "normal",
                          fontWeight: "normal",
                          fontSize: 22,
                          color: "black",
                          marginBottom: 0,
                        }}>
                          {userdata && userdata.roleName}
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <p className="manage-checkbox-css">Department</p>
                      <div className="mar-t-15">
                        <p style={{
                          fontStyle: "normal",
                          fontWeight: "normal",
                          fontSize: 22,
                          color: "black",
                          marginBottom: 0,
                        }}>
                          {userdata && userdata.department}
                        </p>
                      </div>
                    </Col>
                  </Row>



                </Col>
                <Col span="4"></Col>
              </Row>

              <Row
                style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: "-webkit-fill-available"
                }}
              >
                <Col span="2"></Col>
                <Col span="6">
                  <h2 style={{
                    padding: "25px",
                    paddingLeft: "0px",
                    color: "#6b778c",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}>User Department</h2>
                </Col>
                <Col span="14">
                  <Row>
                    <Col span={24}>
                      <p className="manage-checkbox-css">Type</p>
                      <div className="mar-t-15">
                        <p style={{
                          fontStyle: "normal",
                          fontWeight: "normal",
                          fontSize: 22,
                          color: "black",
                          marginBottom: 0,
                        }}>
                          {userdata && userdata.departmentType == 'independentDirectorate' ? 'Independent Directorate' : userdata && userdata.departmentType == 'independentOffice' ? 'Independent Office' : 'Branch'}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={userdata && userdata.departmentType == 'branch' ? 12 : 24}>
                      <p className="manage-checkbox-css">{userdata && userdata.departmentType == 'independentDirectorate' ? 'Independent Directorate' : userdata && userdata.departmentType == 'independentOffice' ? 'Independent Office' : 'Branch'}</p>
                      <div className="mar-t-15">
                        <p style={{
                          fontStyle: "normal",
                          fontWeight: "normal",
                          fontSize: 22,
                          color: "black",
                          marginBottom: 0,
                        }}>
                          {userdata.parentBranch ? userdata && userdata.departmentType == 'branch' ? userdata && userdata.parentBranch : userdata && userdata.departmentTypeName : userdata && userdata.departmentTypeName}
                          {/* {userdata && userdata.departmentType == 'branch' ? userdata && userdata.parentBranch : userdata && userdata.departmentTypeName} */}
                        </p>
                      </div>
                    </Col>

                    {userdata && userdata.departmentType == 'branch' &&
                      <Col span={12}>
                        <p className="manage-checkbox-css">Directorate</p>
                        <div className="mar-t-15">
                          <p style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: 22,
                            color: "black",
                            marginBottom: 0,
                          }}>
                            {!userdata.parentBranch ? "-" : userdata && userdata.departmentTypeName}
                            {/* {userdata && userdata.departmentTypeName} */}
                          </p>
                        </div>
                      </Col>
                    }

                  </Row>
                  {/* <p className="manage-checkbox-css">User Department</p>
                 <div className="mar-l-20 mar-t-15">
                 Type
                  </div> */}


                </Col>
                <Col span="4"></Col>
              </Row>


              <Row
                style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: "-webkit-fill-available"
                }}
              >
                <Col span="2"></Col>
                <Col span="6">
                  <h2 style={{
                    padding: "25px",
                    paddingLeft: "0px",
                    color: "#6b778c",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}>Permissions</h2>
                </Col>
                <Col span="14">
                  <Row style={{ paddingTop: 8 }}>
                    <Col span={24}>
                      {userdata && userdata.type === "Clerk" &&
                        <div className="mar-t-15">
                          <CheckboxGroup
                            options={clerkUsersOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                            value={clerkUsersList}
                            onChange={clerkUsersChange}
                          />
                        </div>
                      }

                      {userdata && userdata.type === "CHD" &&
                        <div className="mar-t-15">
                          <CheckboxGroup
                            options={chdsUsersOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                            value={chdsUsersList}
                            onChange={chdsUsersChange}
                          />
                        </div>
                      }

                      {userdata && userdata.type === "DD's & AD's" &&
                        <div className="mar-t-15">
                          <CheckboxGroup
                            options={adsUsersOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                            value={adsUsersList}
                            onChange={adsUsersChange}
                          />
                        </div>
                      }
                    </Col>
                  </Row>
                  {/* <p className="manage-checkbox-css">Dashboard Tab</p>
                 <div className="mar-l-20 mar-t-15">
               
                  </div> */}


                </Col>
                <Col span="4"></Col>
              </Row>




              <Row
                style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: "-webkit-fill-available"
                }}
              >
                <Col span="2"></Col>
                <Col span="6">
                  <h2 style={{
                    padding: "25px",
                    paddingLeft: "0px",
                    color: "#6b778c",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}>Users Visibility</h2>
                </Col>
                <Col span="14">
                  <Row style={{ paddingTop: 8 }}>
                    <Col span={24}>
                      <div id='scrollableDiv' className="my-user-css">
                        <InfiniteScroll
                          initialLoad={false}
                          pageStart={page}
                          // loadMore={handleInfiniteOnLoad}
                          hasMore={!loading && hasMore}
                          useWindow={false}
                        // scrollableTarget="scrollableDiv"
                        >
                          <List
                            //grid={{ gutter: 16, column: 3 }}
                            // grid={{
                            //   gutter: 16,
                            //   xs: 1,
                            //   sm: 2,
                            //   md: 2,
                            //   lg: 1,
                            //   xl: 1,
                            //   xxl: 1,
                            // }}
                            // itemLayout="horizontal"
                            dataSource={dataSource}
                            renderItem={item => (
                              <List.Item actions={[<Switch
                                checked={item.exclude.length > 0 ? false : true}
                                onChange={(e) => onChange(e, item)}
                              />]}>
                                {/* <Card className="view-users-custom-card-css" style={{ cursor: "pointer", padding: 2 }}> <Switch
            checked={text === "true" ? true : false}
            onChange={(e) => onChange(e, row)}
          /> */}
                                <Popover content={item.username} placement="top" trigger="hover">

                                  <List.Item.Meta
                                    avatar={item.profilePic !== null ? <Avatar src={imagePath + item.profilePic} /> : <Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}> {item.username.charAt(0).toUpperCase()}</Avatar>}
                                    title={
                                      <>
                                        <span style={{'text-transform':'uppercase'}} className="title">{item.username}</span>
                                      </>
                                    }
                                    // description={item.userType}
                                  />

                                </Popover>
                                {/* </Card> */}
                              </List.Item>
                            )}
                          >

                            {loading && hasMore && (
                              <div className="demo-loading-container">
                                <Spin />
                              </div>
                            )}

                          </List>
                        </InfiniteScroll>
                      </div>
                    </Col>
                  </Row>



                </Col>
                <Col span="4"></Col>
              </Row>

              <Form form={form}>

                <Row
                  style={{
                    paddingTop: 20,
                    paddingBottom: 20,
                    width: "-webkit-fill-available"
                  }}
                >
                  <Col span="2"></Col>
                  <Col span="6">
                    <h2 style={{
                      padding: "0px 0px 0px 0px",
                      color: "#6b778c",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}>Communication List</h2>
                  </Col>
                  <Col span="12">
                    <Row>
                      <Col span={24}>
                        <div className="">
                          <p style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: 22,
                            color: "black",
                            marginBottom: 0,
                            paddingLeft: '3px'
                          }}>
                            <Form.Item name={'mydata'} >
                              <Select
                                mode="multiple"
                                className="custom-select-multiple-template ant-select-customize-input"
                                // defaultValue={BranchData ? BranchData : []}
                                onChange={(event, chnagedata) => onOrgListChange(event, chnagedata)}
                                onClick={event => { event.preventDefault() }}
                                style={{ width: "650px" }}
                              >
                                <Option value="None">None</Option>
                                {getOrgUnitList()}

                              </Select>
                            </Form.Item>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col span="4"></Col>
                </Row>

              </Form>


            </div>

          </div>
        </div>
      </Container>
    </>
  );
}
